import dayjs from "dayjs";
import { deleteLeaveRequest } from "firebaseService/firebaseService";
import { X, Trash2 } from "lucide-react";
import { useState } from "react";
import toast from "react-hot-toast";

export const DeleteLeaveForEmployeeModal = ({ employee, approvedLeaves = [], onClose }) => {
    const [submittingId, setSubmittingId] = useState(null);
    const [error, setError] = useState('');

    const handleDelete = async (leaveId) => {
        setSubmittingId(leaveId);
        setError('');
        try {
            await deleteLeaveRequest(leaveId);
            toast.success("Leave request deleted successfully");
        } catch (err) {
            console.error("Error deleting leave request:", err);
            setError('Failed to delete leave. Please try again.');
        } finally {
            setSubmittingId(null);
        }
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 p-4 overflow-y-auto">
            <div className="bg-white rounded-lg shadow-2xl p-8 w-full max-w-2xl">
                <div className="flex justify-between items-center mb-6">
                    <div>
                        <h2 className="text-2xl font-bold text-gray-800">Delete Approved Leaves</h2>
                        <p className="text-gray-600">For: <span className="font-semibold">{employee.name}</span></p>
                    </div>
                    <button onClick={onClose} className="text-gray-500 hover:text-gray-800"><X size={24} /></button>
                </div>

                {approvedLeaves.length === 0 ? (
                    <p className="text-gray-500">No approved leave requests found.</p>
                ) : (
                    <ul className="space-y-4">
                        {[...approvedLeaves]
                            .sort((a, b) => new Date(a.startDate) - new Date(b.startDate))
                            .map((leave) => (
                                <li key={leave.id} className="border rounded-lg p-4 flex justify-between items-start bg-gray-50">
                                    <div>
                                        <p><strong>Type:</strong> {leave.leaveType}</p>
                                        <p><strong>Date:</strong> {dayjs(leave.startDate).format('DD/MM/YYYY')} to {dayjs(leave.endDate).format('DD/MM/YYYY')}</p>
                                        <p><strong>Status:</strong> {leave.status}</p>
                                    </div>
                                    <button
                                        onClick={() => handleDelete(leave.id)}
                                        disabled={submittingId === leave.id}
                                        className="text-red-600 hover:text-red-800 flex items-center gap-1"
                                    >
                                        <Trash2 size={20} />
                                        {submittingId === leave.id ? 'Deleting...' : 'Delete'}
                                    </button>
                                </li>
                            ))}
                    </ul>
                )}

                {error && <p className="text-red-500 text-sm mt-4">{error}</p>}

                <div className="mt-6 flex justify-end">
                    <button onClick={onClose} className="px-4 py-2 bg-gray-200 text-gray-800 rounded-md hover:bg-gray-300">
                        Close
                    </button>
                </div>
            </div>
        </div>
    );
};
